<template>
  <div class="box-info-pass">
    <img id="close" class="close" src="@/assets/img/icons/close.png" alt="" @click="() => toggleIntroducePopup()"/>
    <div class="title">{{ $t('INSTRUCTION_TO_GET_YOUR_MERCHANT_CODE') }}</div>
    <div class="content-step">
      <div class="step-title">{{ $t('INSTRUCTION_1_OPEN_RBH_SHOP_APP') }}</div>
      <img class="one" src="@/assets/img/icons/app-icon.png" alt=""/>
    </div>
    <div class="content-step">
      <div class="step-title">{{ $t('INSTRUCTION_2_CLICK_MENU_ON_THE_TOP_RIGHT') }}</div>
      <img class="two" src="@/assets/img/food/Frame-3013.png" alt=""/>
    </div>
    <div class="content-step last">
      <div class="step-title">{{ $t('INSTRUCTION_3_GET_YOUR_MERCHANT_CODE') }}</div>
      <img class="two" src="@/assets/img/food/Frame-3014.png" alt=""/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoPopup',
  props: {
    toggleIntroducePopup: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
};
</script>

<style scoped>

</style>
